export default {
    opened: {

    },
    active: null
}
